module.exports = __webpack_public_path__ + "static/media/1_r_sculptura_89.69_40.19.f9c4e98b.png";